import Vue from 'vue'
import Vuex from 'vuex'
import _constants from './modules/Constants'

// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = 'production' !== process.env.NODE_ENV

export default new Vuex.Store({
  // initial state - We should keep only App level state here and all other state
  //  in sub-state objects.
  state: {},
  // Actions are similar to mutations, the differences being that:
  //  - Instead of mutating the state, actions commit mutations.
  //  - Actions can contain arbitrary asynchronous operations.
  actions: {},
  // Getters: You can think of them as computed properties for stores. Like
  //  computed properties, a getter's result is cached based on its dependencies,
  //  and will only re-evaluate when some of its dependencies have changed.
  //  - Getters will receive the state as their 1st argument.
  //  - The getters will be exposed on the store.getters object.
  //  - Getters will also receive other getters as the 2nd argument.
  //  - You can also pass arguments to getters by returning a function. This is
  //    particularly useful when you want to query an array in the store.
  //   See https://vuex.vuejs.org/en/getters.html for more details
  getters: {},
  // The only way to actually change state in a Vuex store is by committing a
  //  mutation. Vuex mutations are very similar to events: each mutation has a
  //  string type and a handler
  // Important Note: Mutations must be synchronous in Vuex. If you include async
  //  processing in mutation, it won't be treated as mutation.
  // Important Note: When naming params in mutations DO NOT name them with exactly
  //  the same spelling as a state var as this will cause compiling errors!
  mutations: {
    setFirebaseApp(state, app) {
      state.firebaseApp = app
    },
    setUserAuth(state, auth) {
      state.userAuth = auth
    },
    setUser(state, usrObj) {
      state.user = usrObj
    },
    setUseSecurity(state, use) {
      state.useSecurity = use
    }
    // test (state, val) {
    //   console.log('State: ', state)
    //   console.log('Val: ', val)
    //   state.test = val
    // }
  },
  modules: {
    constants: _constants
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
